import React, { useState, useEffect } from "react";

const LocationHoursEditor = ({ locations = [] }) => {
  const [hours, setHours] = useState([]);

  // Fetch location hours when the component mounts
  useEffect(() => {
    const fetchLocationHours = async () => {
      try {
        // Sending GET request to fetch location hours
        const response = await fetch("/api/cloud/website/getLocationHours");
        if (!response.ok) {
          throw new Error("Failed to fetch location hours");
        }
        const data = await response.json();
        setHours(data); // Assuming the API returns an array of locations with hours
      } catch (error) {
        console.error("Error fetching location hours:", error);
      }
    };

    fetchLocationHours();
  }, []); // Empty dependency array to run only once on mount

  const handleChange = (index, field, value) => {
    const updatedHours = [...hours];
    updatedHours[index][field] = value;
    setHours(updatedHours);
  };

  const handleSave = async (index) => {
    try {
      const response = await fetch("/api/cloud/website/updateLocationHours", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(hours[index]),
      });
      if (!response.ok) {
        throw new Error("Failed to save hours");
      }
      alert("Hours saved successfully!");
    } catch (error) {
      console.error("Error saving hours:", error);
    }
  };

  const fieldClass = "app-input w-full rounded-xl border px-3 py-2 text-sm";

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-1">
        <h2 className="text-lg font-semibold">Location hours</h2>
        <p className="app-muted text-sm">
          Adjust hours per branch. Save updates location by location.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4">
        {hours.map((location, index) => (
          <div
            key={index}
            className="app-surface flex flex-col gap-3 rounded-xl border p-4"
          >
            <h3 className="font-semibold">{location.name}</h3>
            <label className="flex flex-col gap-1">
              <span className="app-muted text-xs font-medium">Mon - Fri</span>
              <input
                type="text"
                className={fieldClass}
                value={location.monFri}
                onChange={(e) => handleChange(index, "monFri", e.target.value)}
              />
            </label>
            <label className="flex flex-col gap-1">
              <span className="app-muted text-xs font-medium">Sat</span>
              <input
                type="text"
                className={fieldClass}
                value={location.sat}
                onChange={(e) => handleChange(index, "sat", e.target.value)}
              />
            </label>
            <label className="flex flex-col gap-1">
              <span className="app-muted text-xs font-medium">Sun</span>
              <input
                type="text"
                className={fieldClass}
                value={location.sun}
                onChange={(e) => handleChange(index, "sun", e.target.value)}
              />
            </label>
            <button
              type="button"
              onClick={() => handleSave(index)}
              className="app-btn app-btn-primary app-btn-sm mt-1 self-start"
            >
              Save hours
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LocationHoursEditor;
